import { render, staticRenderFns } from "./custom-menu-add.vue?vue&type=template&id=4a8bda5c&scoped=true&"
import script from "./custom-menu-add.vue?vue&type=script&lang=js&"
export * from "./custom-menu-add.vue?vue&type=script&lang=js&"
import style0 from "./custom-menu-add.vue?vue&type=style&index=0&id=4a8bda5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8bda5c",
  null
  
)

export default component.exports